import { Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


let desc = '';
let entradaIn = '';
let salidaIn = '';

class Ranking extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            consulta: false,
            busqueda: {
                anio: '',
                escalafon: '',
                serie: '',
            },
            serieBase: [],
            escalafones: [],
            datosConsulta: [],
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
    }
    async componentDidMount(){
        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });
    }
    render(){
        return (
            <>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                <h3>Ranking</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
                {this.state.consulta
                ?
                    null
                :
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Serie</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Escalafon</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='serie' value={this.state.busqueda.serie} onChange={this.manejarCambiosDatos} >
                                            <option value={''}>SERIE CONCURSO</option>
                                            {this.state.serieBase.map((name) =>
                                                <option
                                                key={name.idSerie}
                                                value={name.idSerie}
                                                >{name.descripcion}</option>
                                            )}
                                        </select>
                                    </StyledTableCell>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.busqueda.escalafon} onChange={this.manejarCambiosDatos}>
                                            <option value=''>ESCALAFON</option>
                                            {this.state.escalafones.map((name) =>
                                                <option
                                                key={name.idEscalafon}
                                                value={name.idEscalafon}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Confirmar</button></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </Container>
                }
                {this.state.consulta
                ?
                    <Container>
                        <Table id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center" colSpan={5}></StyledTableCell>
                                    <StyledTableCell align="center" colSpan={4}>ANTIGÜEDAD</StyledTableCell>
                                    <StyledTableCell align="center" colSpan={4}>CALIFICACIÓN</StyledTableCell>
                                    <StyledTableCell>S</StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCell>N</StyledTableCell>
                                    <StyledTableCell>NOMBRE</StyledTableCell>
                                    <StyledTableCell>ESC</StyledTableCell>
                                    <StyledTableCell>GR</StyledTableCell>
                                    <StyledTableCell>SERIE</StyledTableCell>
                                    <StyledTableCell>{this.state.busqueda.anio-1}</StyledTableCell>
                                    <StyledTableCell>{this.state.busqueda.anio}</StyledTableCell>
                                    <StyledTableCell>PROM.</StyledTableCell>
                                    <StyledTableCell>POND.</StyledTableCell>
                                    <StyledTableCell>{this.state.busqueda.anio-1}</StyledTableCell>
                                    <StyledTableCell>{this.state.busqueda.anio}</StyledTableCell>
                                    <StyledTableCell>PROM.</StyledTableCell>
                                    <StyledTableCell>POND.</StyledTableCell>
                                    <StyledTableCell>PUNTAJE ANTECEDENTES</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.datosConsulta.map((name) => (
                                    
                                    <StyledTableRow key={name.numeroFuncionario}>
                                        {this.state.serieBase.map((name2) => {
                                            if(name2.idSerie === name.serie){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.escalafon}</StyledTableCell>
                                        <StyledTableCell>{name.grado}</StyledTableCell>
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.antiguedadAnioAnt}</StyledTableCell>
                                        <StyledTableCell>{name.antiguedadAnio}</StyledTableCell>
                                        <StyledTableCell>{name.antiguedadPromedio}</StyledTableCell>
                                        <StyledTableCell>{name.antiguedadPond}</StyledTableCell>
                                        <StyledTableCell>{name.calificacionAnioAnt}</StyledTableCell>
                                        <StyledTableCell>{name.calificacionAnio}</StyledTableCell>
                                        <StyledTableCell>{name.calificacionPromedio}</StyledTableCell>
                                        <StyledTableCell>{name.calificacionPond}</StyledTableCell>
                                        <StyledTableCell>{name.puntajeAntecedentes}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
            </>
        )
    }
    
    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        if((this.state.busqueda.anio === '')){
            this.setState({
                errores: 'Debe ingrsar el año del ranking',
            })
        }else{
            this.setState({
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.busqueda]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_ranking.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                loading: false,
                errores: exito[0],
            })

            if(exito[0] === 'ok'){
                this.setState({
                    consulta: true,
                    errores: null,
                    notificaciones: null,
                    datosConsulta: exito[1],
                })
            }
        }
    }
}

export default Ranking